
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { CountriesService } from '@core/services/countries.service';
import { TypeaheadSelectOption, TypeSafeFormGroup } from '@yourcause/common';
import { Subscription } from 'rxjs';
import { LookupService } from '../../services/lookup.service';
import { SpecialHandlingFormGroup } from '../special-handling-modal/special-handling-modal.component';
export interface AddressFormGroup {
  name?: string;
  address1: string;
  address2: string;
  countryCode: string;
  city: string;
  stateProvRegCode: string;
  postalCode: string;
}

@Component({
  selector: 'gc-address-block',
  templateUrl: './address-block.component.html',
  styleUrls: ['./address-block.component.scss']
})
export class AddressBlockComponent implements OnInit, OnDestroy {
  @Input() addressFormGroup: TypeSafeFormGroup<AddressFormGroup>|TypeSafeFormGroup<SpecialHandlingFormGroup>;
  @Input() countryDisabled = false;
  @Input() disableInputs = false;
  @Input() enforceCustomStateValidation = true;

  sub = new Subscription();
  regionsExist: boolean;
  countrySelects: TypeaheadSelectOption[] = [];
  regionSelects: TypeaheadSelectOption[] = [];

  constructor (
    private countriesService: CountriesService,
    private lookupService: LookupService
  ) { }

  ngOnInit () {
    this.sub.add(this.countriesService.changesTo$('countries').subscribe((countries) => {
      this.countrySelects = countries.map((country) => {
        return {
          label: country.name,
          value: country.code
        };
      });
    }));
    this.sub.add(this.countriesService.changesTo$('regions').subscribe(async (regionMap) => {
      const countries = this.countriesService.countries;
      const countryCode = this.addressFormGroup.value.countryCode;
      if (countryCode) {
        const country = countries.find(({ code }) => code === countryCode);
        const needToFetch = !regionMap[countryCode] && country.hasState;
        if (needToFetch) {
          const result = await this.lookupService.getStatesByCountryId(country.id);
          this.countriesService.setRegions({
            ...regionMap,
            [countryCode]: result
          });
        }
        this.regionSelects = (this.countriesService.regions[countryCode] || []).map((region) => {
          return {
            label: region.name,
            value: region.code
          };
        });
        if (this.enforceCustomStateValidation) {
          const control = (this.addressFormGroup as TypeSafeFormGroup<AddressFormGroup>).get('stateProvRegCode');
          if (this.regionSelects.length === 0) {
            control.clearValidators();
            control.updateValueAndValidity();
          } else if (!control.hasValidator(Validators.required)) {
            control.addValidators(Validators.required);
            control.updateValueAndValidity();
          }
        }
        this.regionsExist = this.regionSelects.length > 0;
      } else {
        this.regionsExist = false;
      }
    }));
  }

  setRegionsOnCountryChange () {
    this.countriesService.triggerChange('regions');
  }

  ngOnDestroy (): void {
    this.sub.unsubscribe();
  }
}
